<template>
  <div class="style-area">
    <style-image v-for="item in galleryData" :key="item.artist_id"
      :artistData="item" v-on:click="showZoomPortfolio"  />
  </div>
</template>

<script>
import StyleImage from '@/components/widgets/StyleImageHome.vue'

export default {
  components: {
    StyleImage
  },
  props: {
    gallery: Object
  },
  data () {
    return {
      loaded: false,
      galleryData:[]
    }
  },
  created () {
    if(this.gallery){
      this.init()
    }
    
  },
  methods: {
    async init () {
      this.loaded = false
      if(this.gallery.gallery_id){
        console.log('doing fetchGalleryData', this.gallery.gallery_id)
        let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
        if(gd) {
          console.log('gd', gd)
          await this.$store.dispatch('fetchArtists')
          let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
          let lang = this.$store.state.lang.toLowerCase()
          artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
          
          gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
          gd.sort((el, el1) => { return el.rnd - el1.rnd })
          gd = gd.slice(0, 10)
          gd[0].wide = true
          gd[8].big = true
          this.galleryData = gd
          this.loaded = true
        }
      }
      
      
      
    },
    showZoomPortfolio (artist) {
      this.$ixr.push('/artists/' + artist.portfolio_url)
    }
  },
  watch: {
    gallery () {
      if(this.gallery){
        this.init()
      }
    }
  }
}
</script>

<style scoped>
.style-area{
  display:grid;
  grid-template-columns: calc(33.3% - 10px) calc(33.3% - 10px) calc(33.3% - 10px);
  grid-gap:15px;
 
}

.style-area .imdiv{
  position:relative;
}

.style-area .imdiv:first-child{
  grid-column: 1 / 4;
  grid-row-start: 1;
  grid-row-end: 3;
}

@media screen and (min-width:768px){
  .style-area .imdiv:nth-child(9){
    grid-column: 2 / 4;
    grid-row: 5 / 7;
  }
}

@media screen and (max-width:767px){
  .style-area{
    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
    grid-gap:10px;
    grid-template-rows: 15% 15% 15% 15% 15%;
  }
  .style-area .imdiv:first-child {
    grid-column: 1 / 3;
    grid-row: 1;
  }
  .style-area .imdiv:nth-child(10) {
    grid-column: 1 / 3;
    grid-row: 6;
  }
}
</style>